module.exports = __webpack_public_path__ + "static/media/banking-service-counter-female-asian.63d92980.png";